<template>
  <div class="container page">
    <van-nav-bar :title="this.videoInfo.vod_name" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="movie-video">
      <video id="my-video"  :currentTime="currentTime" class="video-js">
      </video>
    </div>
    <div class="movie-content">
      <div class="movie-descript">
        <p>{{ this.videoInfo.vod_name}}</p>
        <span>{{this.videoInfo.count}}{{ $t("playVideo.play") }}</span>
      </div>

      <div class="movie-body">
        <div class="movie-title">
          <div>
            <span>{{ $t("home.hot") }}</span>
          </div>
        </div>
        <div class="movie-list">
          <div class="movie-play-item" @click="toPlayVideo(v.id)" v-for="(v,key) in moreVideoInfo" :key="key">
            <div>
              <img :src="v.vod_pic">
              <div>
                <div class="van-count-down">{{ v.time }}</div>
              </div>
            </div>
            <div>
              <p>{{ v.vod_name }}</p>
              <span>{{ v.count }}{{ $t("playVideo.play") }}</span>
            </div>
          </div>
        </div>
      </div>


    </div>
    <van-popup v-model="show" position="center" round :style="{ width: '80%' }">
      <div class="header">
        Xem video
        <van-icon class="close" @click="show=false" name="cross" />
      </div>
      <div class="content" v-if="userInfo.free_see_time > 0">{{ $t("buy").replace("15", userInfo.free_see_time) }}</div>
      <div class="content" v-else>{{ $t("n_buy") }}</div>

    </van-popup>
  </div>

</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";
export default {
  data() {
    return {
      show:false,
      nowPlayVideoUrl: "",
      isMp4:0,
      type:"",
      cover:"",
      userInfo:[],
      videoInfo:{},
      moreVideoInfo:{},
      player:null,
      is_see: 0,
      is_play:0,
      free_see_time:0,
      currentTime:0
    };
  },
  methods: {
    back(){
      this.$router.push({path:'Home'})
    },
    getVideoInfo(){
      this.$http({
        method: 'get',
        data:{id:this.$route.query.id},
        url: 'video_get_info'
      }).then(res=>{
        this.videoInfo = res.data;
        this.nowPlayVideoUrl = this.videoInfo.vod_play_url;
        this.isMp4 = this.videoInfo.is_mp4;
        this.cover = this.videoInfo.vod_pic;
        let videos = document.getElementById('my-video');
        videos.poster = this.cover;
        this.getVideo();
      })

    },
    toPlayVideo(id){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.$router.push({path:'?id='+id})
        location.reload();
      }

    },
    getMoreVideoItem(){
      this.$http({
        method: 'get',
        url: 'video_get_more_item'
      }).then(res=>{
          this.moreVideoInfo = res.data;
      })
    },
    getVideo() {
      this.player = videojs("my-video",  {
        height:"200px",
        preload: "auto", // 预加载
        controls: true,  // 显示播放的控件
        multipleArray: [0.75, 1, 1.5, 2], // 倍速设置
      });
      this.type = "application/x-mpegURL";
      if(this.isMp4 == 1){
        this.type = "";
      }
      this.player.src([{
        src: this.nowPlayVideoUrl,
        type: this.type // 告诉videojs,这是一个hls流
      }]);
      this.player.currentTime(20)
      var t = this,
          e = this;
      0 == this.is_see && (this.times = setInterval((function() {
        if (t.is_play && 0 == t.is_see) {
          var e = Math.round(t.player.currentTime());
          if (e >= t.free_see_time) return t.player.pause(),
              t.show = true
        }
      }), 1)),
          this.$once("hook:beforeDestroy", (function() {
            e.player.dispose()
          }))
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.is_see = this.userInfo.is_see;
          this.free_see_time = this.userInfo.free_see_time;
          this.is_play = this.$store.getters.getBaseInfo.isplay;
          if(this.userInfo.status !== 1){
            this.$toast(this.$t("msg.账号下线"));
            localStorage.clear()
            this.$router.push({path:'/Login'})
          }else {
            if(this.is_play == 1){
              this.getVideoInfo();
              this.getMoreVideoItem()
              this.show = true

              /*if(this.userInfo.money <= 0){
                this.$toast(this.$t("msg.请充值后观看视频！"));
                this.$router.push({path:'/Home'})
              }*/
            }else {
              this.getVideoInfo();
              this.getMoreVideoItem();
            }
          }
        }else if(res.code ===401){
          this.$toast(this.$t(res.msg));
        }
      })
    },
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  },
  destroyed: function() {
    this.is_play && (this.is_play = !1),
        this.player = null,
        clearInterval(this.times)
  }
};
</script>

<style scoped>
.content {
  color: #775fd9;
  padding: 4vw;
}
.header{
  text-align: center;
  color: #fff;
  padding: 4vw;
  background: linear-gradient(90deg, #775fd9, #000);
  position: relative;
}
.close {
  position: absolute;
  top: 50%;
  right: 4vw;
  transform: translateY(-50%);
}
.video-js {
  width: 100%;
  /*height: 420px;*/
  font-size: 24px;
}
.movie-content{
  flex: 1;
  overflow-y: auto;
}
.movie-content .movie-descript{
  width: 100%;
  height: 140px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 15px;
}
.movie-content .movie-descript p{
  font-size: 30px;
  font-weight: 700;
  color: #000;
}
.movie-content .movie-descript span{
  color: #979799;
}
.movie-content .movie-body{
  width: calc(100% - 20px);
  margin: 0 auto;
}
::v-deep .movie-video .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;
}
.movie-content .movie-body .movie-title{
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.movie-content .movie-body .movie-title>div:first-child {
  width: 100%;
}
.movie-content .movie-body .movie-title>div:first-child span{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 30px;
  font-weight: 700;
  color: #000;
}
.movie-content .movie-body .movie-title>div:first-child span:before {
  content: "";
  display: block;
  width: 8px;
  height: 30px;
  background-color: #7e5678;
  border-radius: 25px;
  margin-right: 10px;
}
.movie-play-item{
  width: 100%;
  height: 200px;
  border-radius: 10px;
  position: relative;
  display: flex;
  background-color: #fff;
  margin-bottom: 20px;
}
.movie-play-item>div{
  height: 100%;
}
.movie-play-item>div:first-child {
  width: 200px;
  position: relative;
}
.movie-play-item>div:first-child>img{
  width: 100%;
  height: 100%;
  border-radius: 10px 0 0 10px;
}
.movie-play-item>div:first-child>div{
  position: absolute;
  width: 100%;
  height: 30px;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  background-color: rgba(0,0,0,.4);
  border-radius: 0 0 0 10px;
}
.movie-play-item>div:first-child>div .van-count-down {
  color: #fff;
  font-size: 25px;
}
.movie-play-item>div:nth-child(2) p{
  width: 500px;
  height: 60px;
  font-size: 30px;
  line-height: 32px;
  word-break: break-all;
  overflow: hidden;
  color: #000;
}
.movie-play-item>div:nth-child(2) span{
  color: #000;
}
.movie-play-item>div:nth-child(2) {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}
</style>